import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as reportAPI from "../../api/report";

const initialState = {
  data: null,
  loading: null,
};

const reportChartPercentage = createAsyncThunk(
  "report/admin/student",
  async (params, { rejectWithValue }) => {
    try {
      //console.log('params', params);
      const res = await reportAPI.reportchart(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
  },
  extraReducers: {
    [reportChartPercentage.pending]: (state) => {
      state.loading = true;
    },
    [reportChartPercentage.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    [reportChartPercentage.rejected]: (state) => {
      state.loading = false;
    },
  },
});

const { resetState } = reportSlice.actions;

export default reportSlice.reducer;

export { resetState, reportChartPercentage };
